declare var BASE_URL:string;
declare var STATIC_BASE_URL:string;

import '../styles/products.scss';
import '../styles/frames.scss';
import '../styles/pricing.scss';
import '../styles/tables.scss';

import { h, Component } from 'preact';

export default class Chatbotstudio extends Component<any, any> {
  
  constructor() {
    super();
    this.state = {active: false};
    this.toggle = this.toggle.bind(this);
  }
  
  toggle (e) {
    this.setState(state => ({active: !state.active}))
    e.preventDefault();
  }
  
  private showYT (e) {
    e.preventDefault();
    this.props.ytCB('3-6LKkXDImE');
  }
  
  public render (props, state): any {
    
    const callToAction = <p class="center calltoaction"><a href="#" class="butt huge" onClick={ this.showYT.bind(this) }>watch demo</a> <a href="./register" class="butt huge">Try it Free</a></p>,
      details = this.state.active ? <section class="animated fadeInUp details">
      <h3>Pricing Details</h3>
      <div class="divTable pricingDetails">
        <div class="divTableBody">
          <div class="divTableRow">
            <div class="divTableCell">&nbsp;</div>
            <div class="divTableCell">FREE</div>
            <div class="divTableCell">Standard</div>
            <div class="divTableCell">Premium</div>
          </div>
          <div class="divTableRow">
            <div class="divTableCell">Unlimited Workflow Length</div>
            <div class="divTableCell"><i class="fa fa-check"></i></div>
            <div class="divTableCell"><i class="fa fa-check"></i></div>
            <div class="divTableCell"><i class="fa fa-check"></i></div>
          </div>
          <div class="divTableRow">
            <div class="divTableCell">Unlimited Number of chats</div>
            <div class="divTableCell">&nbsp;</div>
            <div class="divTableCell"><i class="fa fa-check"></i></div>
            <div class="divTableCell"><i class="fa fa-check"></i></div>
          </div>
          <div class="divTableRow">
            <div class="divTableCell">Unlimited Number of sessions/ month</div>
            <div class="divTableCell">&nbsp;</div>
            <div class="divTableCell">&nbsp;</div>
            <div class="divTableCell"><i class="fa fa-check"></i></div>
          </div>
          <div class="divTableRow">
            <div class="divTableCell">NLU access</div>
            <div class="divTableCell">&nbsp;</div>
            <div class="divTableCell"><i class="fa fa-check"></i></div>
            <div class="divTableCell"><i class="fa fa-check"></i></div>
          </div>
          <div class="divTableRow">
            <div class="divTableCell">Add-ons access</div>
            <div class="divTableCell">&nbsp;</div>
            <div class="divTableCell"><i class="fa fa-check"></i></div>
            <div class="divTableCell"><i class="fa fa-check"></i></div>
          </div>
          <div class="divTableRow">
            <div class="divTableCell">API Integration</div>
            <div class="divTableCell">&nbsp;</div>
            <div class="divTableCell">&nbsp;</div>
            <div class="divTableCell"><i class="fa fa-check"></i></div>
          </div>
        </div>
      </div>
    </section> : '',
      detailsButt = this.state.active ? <span><i class="fa fa-sort-up"></i> See less details</span> : <span><i class="fa fa-sort-down"></i> See more details</span>;
  
    return <div id="chatbotstudio" class="product">
      <div class="mainWrp">
        <section class="body center">
          <h1>Chatbot Studio</h1>
          <h2 class="content">
            Want to create your own Conversational AI solution?
          </h2>
          { callToAction }
        </section>
      </div>
      <div class="mainWrp frameWrp">
          <div class="col">
            <div class="frame macbookair">
              <img class="frameImg" src={STATIC_BASE_URL + 'images/public/frame_macbookair.png'} alt="Chatbot Studio" />
              <div class="inframeWrp">
                <img class="inframe" src={ STATIC_BASE_URL + 'images/public/products_chatbot-studio.png'} alt="Chatbot Studio" />
              </div>
            </div>
          </div>
          <div class="col padLeft">
            <h2>Create your chatbot in few minutes, zero coding knowledge needed!</h2>
            <p>
              Our powerful graphic chatbot builder can make your dreams come true.
              Customizable with your creative design and rich media, backed up by cutting edge AI technology from our partners such as IBM and Microsoft, this Chatbot Studio is a monster that enables you to create and post your own conversation AI solution in few minutes!​
            </p>
          </div>
          <br style="clear:both" />
      </div>
      <section class="full grey">
        <p>
          You cannot fully understand the potential power and current limitations of Conversational AI if you never tried to make one yourself.​
        </p>
        <p>
          Querlo's Chatbot Studio offers you the platform where you can easily create your own Conversational AI. Starting with simple deterministic flow, you can gradually elevate to more complicated NLU capabilities and other top APIs integrations, where you can get hands on experience of creating, using, and monitoring what a Conversational AI chatbot has to offer!​
        </p>
        <p>
          Our Chatbot Studio is highly customizable and easy to play with. You can build a chatbot that fits your brand by using all sorts of images, emojis, videos, and other additional attachment and functionality in addition to text. Why not owning your personal AI in just a few clicks?​
        </p>
      </section>
      <blockquote>
        "Elements of AI like machine learning, natural language processing, and neural networks are poised to power the next wave of a digital revolution.”​
        <span>Verizon</span>
      </blockquote>
    
      <section class="features center cols full">
        <div class="mainWrp">
          <h2>Benefits</h2>
          <div class="col">
            <div class="col first">
              <h3><i class="fa fa-swatchbook"></i> Own AI in few minutes</h3>
              <p>
                Starting with our templates, you can create a simple and intelligent chatbot in just few minutes. No need to feel overwhelmed by the word "AI" - you can play with your own AI anytime.​
              </p>
            </div>
            <div class="col">
              <h3><i class="fa fa-undo-alt"></i> Full Control</h3>
              <p>
                When you have access to our backend, you are taking full control of your conversational AI, where you can customize your chatbot to your liking, view analytics reports and real time responses.
              </p>
            </div>
          </div>
          <div class="col">
            <div class="col">
              <h3><i class="fa fa-grin-hearts"></i> Understand Sentiments</h3>
              <p>
                You can develop real sentiment analysis. Learn if the user is having a good experience or if at some point the chat should be forwarded to a real human. ​
              </p>
            </div>
            <div class="col">
              <h3><i class="fa fa-brain"></i> Conversational intelligence</h3>
              <p>
                You can develop intelligent conversation to sound more human like based on NLU capabilities. ​
              </p>
            </div>
          </div>
        </div>
      </section>
      <section class="features full center cols grey">
        <h2>Features</h2>
        <div class="mainWrp">
          <div class="col">
            <div class="col first">
              <h3><i class="fa fa-mouse-pointer"></i> Graphical</h3>
              <p>
                Build everything in simple clicks. Conversational flow is easy to grasp in our decision tree format.
              </p>
            </div>
            <div class="col">
              <h3><i class="fa fa-laptop-code"></i> Easy Posting</h3>
              <p>
                Simple copy and paste the JS into your web code source, and have the chatbot sitting on your website in an iframe or pop-up window.
              </p>
            </div>
          </div>
          <div class="col">
            <div class="col">
              <h3><i class="fa fa-chart-bar"></i> Analytics​</h3>
              <p>
                Our powerful analytics dashboard will provide all the insights you need to know your audience and business performance.
              </p>
            </div>
            <div class="col">
              <h3><i class="fa fa-swatchbook"></i> Highly customizable</h3>
              <p>
                Most elements of the chat is customizable – insert your own media, upload avatar, and even select the language.
              </p>
            </div>
          </div>
        </div>
        <div class="mainWrp">
          <div class="col allalone">
            <div class="col">
              <h3><i class="fa fa-tape"></i> API integration</h3>
              <p>
                Easily connectable with various external and internal APIs with simple click.
              </p>
            </div>
            <div class="col">
              <h3><i class="fa fa-language"></i> NLU</h3>
              <p>
                Implement the NLU function to make your chatbot more intelligent! Train NLU model on your own or use the power of cloud sourcing from our AI social lab.
              </p>
            </div>
          </div>
        </div>
      </section>
      <div class="mainWrp">
        <section>
          { callToAction }
        </section>
      </div>
      {/*<div class="mainWrp">
        <section class="plansWrp">
          <h2>Pricing</h2>
          <ul class="plans">
            <li>
              <div>
                <h3>Starter</h3>
                <p class="price">
                  FREE
                </p>
                <p class="time">usd/month</p>
              </div>
            </li><li class="tall">
              <div>
                <p class="pop">
                  Most Popular
                </p>
                <h3>Standard</h3>
                <p class="price">
                  $50
                </p>
                <p class="time">usd/month</p>
              </div>
            </li><li>
              <div>
                <h3>Premium</h3>
                <p class="price">
                  <a href="mailto:info@querlo.com" class="contactUs">Contact us</a>
                </p>
              </div>
            </li>
          </ul>
          <button class="moreDetails" onClick={this.toggle}>
            { detailsButt }
          </button>
          
        </section>
        { details }
      </div>
      <section class="full">
        { callToAction }
      </section>*/}
    </div>
  }
}


// WEBPACK FOOTER //
// ./ts/Chatbotstudio.tsx